<router-outlet><app-spinner></app-spinner>  <toaster-container></toaster-container>
</router-outlet>
